"use client"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

export function NewsletterForm() {
  return (
    <form
      className="flex gap-2"
      onSubmit={(e) => e.preventDefault()}
    >
      <Input
        type="email"
        placeholder="Your email"
        className="bg-white/10 border-white/10 text-white placeholder:text-white/40 h-10 text-sm"
      />
      <Button
        size="sm"
        className="bg-amber-500 hover:bg-amber-600 text-white shrink-0"
      >
        Subscribe
      </Button>
    </form>
  )
}
